export default {
    'Karmiel': 'כרמיאל',
    'Home': 'כללי',
    'Info': 'מידע',
    'Map': 'מפה',
    'Profile': 'פרופיל',
    'Log In': 'התחברות',
    'General': 'כללי',
    'Settings': 'הגדרות',
    'Logout': 'התנתקות',
    'Login': 'התחברות',
    'Password': 'סיסמה',
    'Email address': 'כתובת אימייל',
    'Enter email': 'הכניסו כתובת אימייל',
    'Forgot password?': 'שכחת סיסמה?',
    'OR': 'או',
    'Sign Up': 'הרשמה',
    'Empty email': 'כתובת אימייל ריקה',
    'Invalid email format': 'פורמט כתובת אימייל שגוי',
    'Empty password': 'סיסמה ריקה',
    'Logging in...': 'מתבצעת התחברות...',
    'Passwords don\'t match': 'הסיסמאות אינן תואמות',
    'Creating new account...': 'יוצר חשבון חדש...',
    'Failed to create account:': 'יצירת החשבון נכשלה:',
    'Confirm Password': 'אישור סיסמה',
    'Cancel': 'ביטול',
    'Change Password': 'שנה סיסמה',
    'Delete Account': 'מחק חשבון',
    'My Rewards': 'הפרסים שלי',
    'My Wallet': 'הארנק שלי',
    'All Rewards': 'כל הפרסים',
    'Shops': 'חנויות',
    'Family Park': 'פארק המשפחה',
    'Retro Cars': 'מכוניות רטרו',
    'Sculptures': 'פסלים',
    'Dance Festival': 'פסטיבל ריקודים',
    'Beyond Streets': 'מעבר לרחובות',
    'City Zoo': 'פינת החי', 
    'Space Aliens': 'פולשי החלל', 
    'Assemble JWST': 'תרכיבו טלסקופ', 
    'Quests': 'משימות',
    'Rewards': 'פרסים',
    'Public Art': 'אמנות ציבורית',
    'Karmiel Digital': 'כרמיאל דיגיטל',
    //settings
    'Email': 'אימייל',
    'Current Password': 'סיסמה נוכחית',
    'New Password': 'סיסמה חדשה',
    'Confirm New Password': 'אישור סיסמה חדשה',
    'Enter Your Password': 'הזן את הסיסמה שלך',
    'Save Changes': 'שמור שינויים',
    'Display Name': 'שם תצוגה',
    //categories
    'Activities': 'הפעילות', 
    'All': 'כולם', 
    'Storyville': 'סטוריוויל',
    'Music Therapy': 'תרפיה במוזיקה',
    'Heritage Trail': 'שביל המורשת',
    'Gillie and Marc': 'גילי ומארק',
    'ArtWall': 'קיר אמנות',
    'Tree Watering': 'השקיית עצים',
    'Maps': 'מפות',
    'Teachable': 'חינוכי',
    'Not Here': 'לא כאן',
    'Games': 'משחקים',
    'PerX Partners': 'שותפי PerX',
    //sliders
    'onboarding_slide1_title': 'ברוכים הבאים ל-DimensionX!',
    'onboarding_slide1_description': 'זהו עולם שבו המרחב הדיגיטלי והפיזי נפגשים. DimensionX הוא חלון לעולם המציאות, (AR)שסביבכם  המוטבע בעולם האמיתי הרבודה.',
    'onboarding_slide2_title': 'AR תגלו מקומות עם תמיכה',
    'onboarding_slide2_description': '.תמצאו מקומות עם תמיכה סמלי מידע ועצות לצילום יעזרו לך למצוא את דרכך ולהגיע למקום הנכון.',
    'onboarding_slide3_title': 'תלצלולו לתוך העולם הדיגיטלי',
    'onboarding_slide3_description': 'כאשר אתה שם, פתח את המצלמה באפליקציה והחלק בעדינות את הטלפון מצד לצד .תוכן המציאות הרבודה יופיע ברגע שהאפליקציה תזהה את המיקום שלך',
    'onboarding_slide4_title': 'תאסוףו בונוסים',
    'onboarding_slide4_description': 'בזמן שאתם חוקרים את מרחב המציאות הרבודה, תחפשו מטבעות זהב! תלחצו עליהם כפי שאתם רואים.',
    'onboarding_slide5_title': 'מוכנים להחלפת בונוסים?',
    'onboarding_slide5_description': 'תפתחו את הארנק שלכם באפליקציה כדי להציג מטבעות שנאספו ולקבל הצעות בלעדיות משותפים מקומיים.',
    'NEXT': 'הלאה',
    'GET STARTED': 'להתחיל',
    'Skip': 'דלג'
}
